<template>
  <section class="detail-reference-page">
    <div class="detail-reference-page__title detail-reference-page__title--with-action">
      <div>
        <h1>岗位能力类方向老师</h1>
        <p>成绩查询</p>
      </div>
      <router-link to="/post-ability" class="query-button detail-reference-page__query">重新查询</router-link>
    </div>

    <p v-if="errorMessage" class="status-text status-text--error">{{ errorMessage }}</p>
    <div v-else-if="loading" class="scores-empty-state">
      <h3>正在查询成绩详情</h3>
      <p>请稍候，系统正在加载考生成绩信息。</p>
    </div>
    <div v-else-if="detail" class="detail-reference-paper">
      <div class="detail-info-panel">
        <div class="detail-panel-title">老师信息</div>
        <div class="detail-info-panel__body">
          <div class="detail-info-panel__meta">
            <div class="detail-info-panel__row">
              <span>老师姓名：</span>
              <strong>{{ detail.candidateName || '--' }}</strong>
            </div>
            <div class="detail-info-panel__row">
              <span>报名号：</span>
              <strong>{{ candidateNo }}</strong>
            </div>
            <div class="detail-info-panel__row">
              <span>身份证号：</span>
              <strong>{{ detail.idCardMasked || '--' }}</strong>
            </div>
          </div>
          <div class="detail-info-panel__qr">
            <div class="detail-info-panel__avatar-box">
              <img v-if="detail.avatar" :src="detail.avatar" :alt="`${detail.candidateName || '老师'}头像`" class="detail-info-panel__avatar">
              <span v-else>暂无头像</span>
            </div>
          </div>
        </div>
      </div>

      <div class="detail-exam-summary">
        <span>考试：</span>
        <strong>岗位能力类专业</strong>
      </div>

      <div class="detail-score-table">
        <div class="detail-score-table__head detail-score-table__row">
          <span>考试名称</span>
          <span>科目等级</span>
          <span>成绩状态</span>
        </div>
        <div v-for="item in recentRecords" :key="item.candidateId" class="detail-score-table__row detail-score-table__row--list">
          <span>{{ item.examName || '--' }}</span>
          <span>{{ formatSubjectLevel(item) }}</span>
          <span class="detail-score-table__score">{{ item.certificateStatus || '--' }}</span>
        </div>
      </div>

      <div class="detail-reference-paper__foot">
        <router-link to="/" class="query-button detail-reference-paper__back">返回首页</router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { fetchPostAbilityScoreDetail, fetchPostAbilityScoreList } from '@/api/portal'

export default {
  name: 'ScoreDetailPage',
  data() {
    return {
      loading: false,
      errorMessage: '',
      detail: null,
      recentRecords: []
    }
  },
  computed: {
    candidateId() {
      return this.$route.params.candidateId
    },
    candidateNo() {
      if (!this.detail) {
        return '--'
      }
      return this.detail.admissionNo || this.detail.candidateId || '--'
    }
  },
  watch: {
    candidateId() {
      this.loadDetail()
    }
  },
  created() {
    this.loadDetail()
  },
  methods: {
    formatSubjectLevel(item) {
      const subject = item.subject || '--'
      return item.level ? `${subject}（${item.level}）` : subject
    },
    async loadDetail() {
      this.loading = true
      this.errorMessage = ''

      try {
        const [detail, recentRecords] = await Promise.all([
          fetchPostAbilityScoreDetail(this.candidateId),
          fetchPostAbilityScoreList()
        ])
        this.detail = detail
        this.recentRecords = recentRecords || []
      } catch (error) {
        this.detail = null
        this.recentRecords = []
        this.errorMessage = error.message || '成绩详情加载失败'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
